import { Container, Box } from '@mui/material'
import React from 'react'
import { WarrantyRegistrationsTable } from '../components/data/warranty/WarrantyRegistrationsTable'
import FloatingActionButton from '../components/ui/FloatingActionButton'
import AddIcon from '@mui/icons-material/Add'
import { Link } from 'react-router-dom'
import WarrantyRegistrationsList from '../components/data/warranty/WarrantyRegistrationsList'

const Dashboard = () => {
  return (
    <Container maxWidth='xl' sx={{ p: 2, maxWidth: '100vw' }}>
      <WarrantyRegistrationsTable />
    </Container>
  )
}

export default Dashboard
